import React from 'react';
import { useParams } from 'react-router-dom';
import AgentBuilder from '../components/AgentBuilder';

const EditAgent = () => {
  const { id } = useParams();

  return <AgentBuilder agentId={id} />;
};

export default EditAgent;
